/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventtitlerequired2Inputs */

const en_eventtitlerequired2 = /** @type {(inputs: Eventtitlerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event title is required`)
};

const de_eventtitlerequired2 = /** @type {(inputs: Eventtitlerequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventtitel fehlt`)
};

/**
* | output |
* | --- |
* | "Event title is required" |
*
* @param {Eventtitlerequired2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventtitlerequired2 = /** @type {((inputs?: Eventtitlerequired2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventtitlerequired2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventtitlerequired2(inputs)
	return de_eventtitlerequired2(inputs)
});
export { eventtitlerequired2 as "eventTitleRequired" }